(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/router.js');

'use strict';

const playViews = {
  Single: svs.eurojackpot.views.PlaySinglePage,
  System: svs.eurojackpot.views.PlaySystemPage,
  Package: svs.eurojackpot.views.PlayPackagePage
};
svs.eurojackpot.Router = Backbone.Router.extend({
  routes: svs.core.data.routes,
  initialize(_ref) {
    let {
      app
    } = _ref;
    svs.eurojackpot.logger.debug('svs.router.eurojackpot initialize');
    this.app = app;
  },
  playSingle() {
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router single');
    this.app.showView(new svs.eurojackpot.views.PlaySinglePage());
  },
  playPackageGame(size) {
    if (!size) {
      size = '200';
      Backbone.history.navigate("fardiga-spel/".concat(size), {
        replace: true
      });
    }
    svs.core.data.title = {
      packageSize: size
    };
    svs.core.data.metaDescription = {
      packageSize: size
    };
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router packageGame', size);
    this.app.showView(new svs.eurojackpot.views.PlayPackagePage({
      size
    }));
  },
  playSystem() {
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router system');
    this.app.showView(new svs.eurojackpot.views.PlaySystemPage());
  },
  playProlongation() {
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router prolongWager');
    if (!svs.eurojackpot.data.prolongWager) {
      svs.eurojackpot.logger.warn('svs.eurojackpot.Router prolongWager. No wager to prolong.');
      this.navigate('', {
        trigger: true,
        replace: true
      });
    }
    const editWagerFunction = svs.numbergames.game.utils.prolongation.getEditWagerFunction({
      playViews,
      modelOptions: {
        hasTickets: svs.eurojackpot.data.hasTickets
      }
    });
    const playedWagerModel = new svs.numbergames.mybets_common_wager.models.Wager(svs.eurojackpot.data.prolongWager, {
      parse: true
    });
    editWagerFunction(playedWagerModel);
  },
  changeSubscription() {
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router changeSubscription');
    const subscription = new svs.numbergames.mybets_common_wager.models.Subscription(svs.eurojackpot.data.subscription, {
      parse: true
    });
    svs.numbergames.game.utils.editWager.showPlayView({
      playedWager: subscription,
      modelOptions: {
        noEmptyBoards: true,
        rules: svs.numbergames.rules.getRules({
          productId: svs.numbergames.productMapping.CONSTANTS.EUROJACKPOT
        })
      },
      playViews,
      viewOptions: {
        showDrawCount: false,
        showAccountSelector: false
      }
    });
  },
  fractionGames() {
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router fractionGames');
    this.app.showView(new svs.eurojackpot.views.FractiongamesPage());
  },
  prolongation() {
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router prolongation');
    const hasSession = svs.numbergames.game_app.utils.handleProlongLogin();
    if (hasSession) {
      this.app.showView(new svs.eurojackpot.views.ProlongationPage());
    }
  },
  result(dateString) {
    if (dateString) {
      try {
        const date = dateFns.parseISO(dateString);
        const readableDate = dateFns.format(date, 'd MMMM yyyy', {
          locale: dateFns.locales.sv
        });
        svs.core.data.title = {
          readableDate
        };
        svs.core.data.metaDescription = {
          readableDate
        };
      } catch (e) {
        svs.eurojackpot.logger.error('svs.eurojackpot.Router result failed to parse date', e);
      }
    }
    svs.eurojackpot.logger.debug('svs.eurojackpot.Router result');
    this.app.showView(new svs.eurojackpot.views.ResultPage({
      dateString
    }));
  }
});

 })(window);